import { Button, Heading, Mockups, Section } from 'components'
import React from 'react'
import * as Styles from './Hero.module.css'
import parseHtml from 'utils/parseHtml'

const Hero = ({ heading, text, buttons = [], kicker }) => {
  return (
    <Section>
      <div className={Styles.wrapper}>
        <div className={Styles.content}>
          <Heading type="kicker">{kicker}</Heading>
          <Heading level="1">{heading}</Heading>
          <div className={Styles.leadingText}>{parseHtml(text)}</div>

          <div className={Styles.buttonWrapper}>
            {buttons.map((button) => (
              <Button
                key={button.label}
                type={button.type}
                to={button.destination.uri}
                icon={button.icon}
              >
                {button.label}
              </Button>
            ))}
          </div>
        </div>

        <div className={Styles.media}>
          <Mockups.LeadScore />
        </div>
      </div>
    </Section>
  )
}

export default Hero
